export const WITHDRAW_APPLIED_JOB_REQUEST = ' WITHDRAW_APPLIED_JOB_REQUEST'
export const WITHDRAW_APPLIED_JOB_SUCCESS = ' WITHDRAW_APPLIED_JOB_SUCCESS'
export const WITHDRAW_APPLIED_JOB_FAILED = 'WITHDRAW_APPLIED_JOB_FAILED'
